import type { FC } from "react";
import useTranslations from "../../i18n/useTranslations";
import type { Milestone } from "../../types";

type Props = {
  milestone: Milestone;
  done: boolean;
  color?: string;
};

const TierRung: FC<Props> = ({ milestone, done, color }) => {
  const t = useTranslations();

  return (
    <div
      data-slot="tier-rung"
      data-done={done}
      className="flex shrink-0 items-center gap-2.5 rounded-lg bg-foreground/5 py-2.5 pr-3 pl-2.5 font-semibold text-sm"
    >
      {done && (
        <span
          className="size-5 rounded-full"
          style={{ backgroundColor: color }}
        />
      )}
      {!done && (
        <span className="size-5 rounded-full border-[1.5px] border-foreground/25 bg-foreground/10" />
      )}
      <span className="flex-1 opacity-70">{milestone.name}</span>
      <span className="opacity-70">
        {t("reward_center.tier.xp_amount", {
          points: Number(milestone.points).toLocaleString(),
        })}
      </span>
    </div>
  );
};

export default TierRung;
